// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1AZp_","tab":"Tabs_tab__2NPWP","tabActive":"Tabs_tabActive__29vnd"};